import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

import { PLAYER_DEBUG_KEY } from '../constants/debugKey';
import { playerLogger } from '../utils/playerLogger';

export const usePlayerDebug = () => {
  const [value, setValue] = useLocalStorage(PLAYER_DEBUG_KEY, false);

  const onClear = useCallback(() => {
    console.info('Clearing player debug');
    setValue(false);
  }, [setValue]);

  const onToggle = useCallback(() => {
    if (!value) {
      playerLogger({ location: 'usePlayerDebug', message: 'Enabling player debug' });
      setValue(true);
    } else {
      playerLogger({ location: 'usePlayerDebug', message: 'Disabling player debug' });
      setValue(false);
    }
  }, [setValue, value]);

  return { onClear, onToggle, value };
};
